import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Mode maquette (dev uniquement) : REACT_APP_MOCK=1 npm start → API simulée
// en mémoire (données fictives). La condition est évaluée à la compilation :
// en build de production, NODE_ENV vaut "production" et le module n'est pas
// inclus dans le bundle.
if (process.env.NODE_ENV !== "production" && process.env.REACT_APP_MOCK === "1") {
  require("./mock").installMockApi();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
